export default __webpack_public_path__ + "static/media/biz-partnership.5068bb70.svg";